/*
 * Copyright (c) Arbeidskracht Groep B.V. - all rights reserved
 */

import {createAction} from 'typesafe-actions';

export const stompClientConnectionEstablished = createAction('STOMP_CLIENT_CONNECTION_ESTABLISHED')<{ clientIdentifier: string }>();

export const stompClientWebSocketErrorOccurred = createAction('STOMP_CLIENT_WEB_SOCKET_ERROR_OCCURRED')<{ clientIdentifier: string }>();

export const stompClientSubscribedToTopic = createAction('STOMP_CLIENT_SUBSCRIBED_TO_TOPIC')<{ topic: string }>();

export const stompClientUnsubscribedFromTopic = createAction('STOMP_CLIENT_UNSUBSCRIBED_FROM_TOPIC')<{ topic: string }>();

export const stompMessageReceived = createAction('STOMP_MESSAGE_RECEIVED')<{ topic: string, eventType: string, eventBody: JSON }>();
